import React, { useRef, useState } from 'react';
import Grid from '@components/Grid';
import Cell from '@components/Cell';
import Input from '@components/Input';

interface IDate {
  day?: number | undefined;
  month?: number | undefined;
  year?: number | undefined;
}

export interface DayOfBirthProps {
  value?: IDate;
  name?: string;
  onChange?: (e: any) => void;
  error?: any;
}

function DayOfBirth({ value, onChange, name, error }: DayOfBirthProps) {
  const [date, setDate] = useState<IDate | undefined>(value);
  const refMonth = useRef<HTMLDivElement>(null)
  const refYear = useRef<HTMLDivElement>(null)

  const handleChange = (event: any) => {
    ;
    const { value, name: nameTarget, maxLength } = event.target;
    switch (nameTarget) {
      case 'day':
        if (value.length === maxLength || value.length > maxLength) {
          refMonth.current?.getElementsByTagName('input')[0].focus();
          console.log(refMonth);
        }
        break;
      case 'month':
        if (value.length === maxLength) {
          refYear.current?.getElementsByTagName('input')[0].focus()
        }
        break;
      case 'year':
        break;
      default: break;
    }
    const nextDate = { ...date, [nameTarget]: value };
    setDate(nextDate);
    if (onChange) {
      onChange({ ...event, target: { ...event.target, name, value: nextDate } });
    }
  };

  return (
    <Grid columns="64px 64px 73px" justifyContent="space-around" gap="20px">
      <Cell>
        <Input value={date?.day} textAlign="center" invalid={error} type="numeric" onChange={handleChange} name="day" placeholder="DD" maxLength={2}></Input>
      </Cell>
      <Cell>
        <Input value={date?.month} textAlign="center" invalid={error} type="numeric" padding="13px 18px" onChange={handleChange} name="month" placeholder="MM" maxLength={2} ref={refMonth}></Input>
      </Cell>
      <Cell>
        <Input value={date?.year} textAlign="center" invalid={error} type="numeric" onChange={handleChange} name="year" placeholder="YYYY" maxLength={4} ref={refYear}></Input>
      </Cell>
    </Grid>
  );
};

export default DayOfBirth;
